import { render } from "./user-profiles.vue?vue&type=template&id=ef24f2f0&lang=pug"
import script from "./user-profiles.vue?vue&type=script&lang=js"
export * from "./user-profiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__